module.exports = __webpack_public_path__ + "img/solar.3df4cb9b.png";